import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';
import {RestService} from "../shared/rest/rest.service";

@Component({
  selector: 'app-logout-iframe',
  templateUrl: './logout-iframe.component.html',
  styleUrls: ['./logout-iframe.component.scss']
})
export class LogoutIframeComponent implements OnInit, AfterViewInit {


  public initialized = false;

  public _url: IUrl;

  @Input()
  public set url(value: IUrl) {
    this._url = value;
    this.initialized = true;
  }

  public get url() {
    return this._url
  }


  @Output()
  public completedLogout = new EventEmitter<IUrl>()

  constructor(private restService: RestService) {
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    if (this.url.useGet) {
      this.makeGet();
    } else {
      this.makePost();
    }

  }

  makePost(init = false) {
    this.restService.makePost(this.url.logoutUrl, undefined).subscribe(() => {
      this.completedLogout.emit(this.url)
    }, (err) => {
      console.warn("Error during post", this.url.logoutUrl, err);
      this.completedLogout.emit(this.url)
    }, () => this.completedLogout.emit(this.url))
  }

  makeGet() {
    this.restService.makeGet(this.url.logoutUrl).subscribe(() => {
      this.completedLogout.emit(this.url)
    }, (err) => {
      console.warn("Error during get", this.url.logoutUrl, err);
      this.completedLogout.emit(this.url)
    }, () => this.completedLogout.emit(this.url))
  }

}

export class IUrl {

  public logoutUrl: string;

  public useGet: boolean;

  constructor(args?: { logoutUrl: string, useGet: boolean }) {
    this.logoutUrl = args?.logoutUrl;
    this.useGet = args?.useGet;
  }
}
